<template>
    <div id="ResultadoCitatorio_div">
        <div id="TituloConsultaDireccion_div" class="w-100">
            <h1 style="margin-bottom: 0px;">Resultado de cédula</h1>
             <h3 style="margin-top: 0px;">Resultado de citatorio</h3>
        </div>    
        <div id="contendor-formulario-resultadoCedulaCitatorio" class="padding-div-low" style="padding-bottom: 0px;">
            <ul class="nav nav-tabs" id="nav-tab-formulario-cedula" role="tablist" >                
                <li class="nav-item">
                    <a class="nav-link active" id="datos-generales-cedula-tab" data-toggle="tab" href="#datos-generales-cedula" role="tab" aria-controls="datos-generales-cedula" aria-selected="true"><i class="fas fa-edit"></i>&nbsp;Datos generales de cédula</a>
                </li>                                    
                <li class="nav-item">
                    <a class="nav-link" id="archivos-resultado-cedula-tab" data-placement="top" data-toggle="tab" href="#archivos-resultado-cedula" role="tab"  aria-controls="archivos-resultado-cedula" aria-selected="true"><i class="fas fa-file-alt"></i>&nbsp;Archivos de cédula</a>
                </li>                    
                <li class="nav-item">
                    <a class="nav-link" id="resultado-cedula-tab" data-placement="top" data-toggle="tab" href="#resultado-cedula" role="tab"  aria-controls="resultado-cedula" aria-selected="true"><i class="fas fa-chalkboard-teacher"></i>&nbsp;Resultado de cédula </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link disabled" id="generar-archivoresultado-cedula-tab" data-placement="top" data-toggle="tab" href="#generar-archivoresultado-cedula" role="tab"  aria-controls="generar-archivoresultado-cedula" aria-selected="true"><i class="fas fa-file-upload"></i>&nbsp;Archivo de resultado</a>
                </li>
            </ul>
        </div>
        <div class="nav_tab_formularios">
            <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" id="datos-generales-cedula" role="tabpanel" aria-labelledby="datos-generales-cedula-tab">
                    <div style="display: flex;">
                        <div class="row col-12">
                            <div class="col-12">
                                <h6>Expediente</h6>
                                <hr style="height:1px;border:none;color:#FFF;background-color:#FFF;"/>
                            </div>
                            <div class="col-4 form-group">
                                <h6>Juzgado</h6>
                                <input disabled="disabled" v-model="cedulaConResultado.Expediente.Juzgado.Nombre" type="text" class="form-control" />
                            </div>
                            <div class="col-4 form-group">
                                <h6 for="cedula_tipoDocumento">Tipo de documento</h6>
                                <input disabled="disabled" v-model="cedulaConResultado.Expediente.TipoDocumento.Nombre" type="text" id="cedula_tipoDocumento" class="form-control"/>
                            </div>
                            <div class="col-4 form-group">
                                <h6 for="cedula_numeroDocumento">Consecutivo</h6>
                                <input disabled="disabled" v-model="cedulaConResultado.Expediente.NumeroDeDocumento" type="text" id="cedula_numeroDocumento" class="form-control"/>
                            </div>
                            <div class="col-4 form-group" v-if="cedulaConResultado.Expediente.TipoDocumento.TipoDocumentoId == 2 || cedulaConResultado.Expediente.TipoDocumento.TipoDocumentoId == 10">
                                <h6 for="cedula_numeroDocumento">Número</h6>
                                <input disabled="disabled" v-model="cedulaConResultado.Expediente.Consecutivo" type="text" id="cedula_numeroDocumento" class="form-control"/>
                            </div>
                            <div class="col-12">
                                <h6>Cédula</h6>
                                <hr style="height:2px;border:none;color:#FFF;background-color:#FFF;"/>                                                             
                            </div>
                            <div class="col-4 form-group">
                                <h6 for="cedula_tipoCedula">Tipo de cédula</h6>                                        
                                <input disabled="disabled" v-model="cedulaConResultado.TipoCedula.Nombre" type="text" id="cedula_tipoCedula" class="form-control"/>
                            </div>
                            <div class="col-4 form-group">
                                <h6 for="cedula_jurisdiccion">Área encargada</h6>                                        
                                <input disabled="disabled" :value="cedulaConResultado.Jurisdiccion.Area.Nombre" v-on:input="cedula.Jurisdiccion.Area.Nombre = $event.target.value.toUpper()" type="text" id="cedula_jurisdiccion" class="form-control"/>
                            </div>
                            <div class="col-4 form-group">
                                <h6 for="cedula_urgente">Urgente</h6>                                                                               
                                <input disabled="disabled" v-if="cedulaConResultado.Urgente" value="Si" type="text" class="form-control"/>
                                <input disabled="disabled" v-else value="No" type="text" class="form-control"/>                                        
                            </div>
                            <div class="col-12 form-group">
                                <h6 for="cedula_acuerdos">Acuerdos</h6> 
                                <hr style="height:1px;border:none;color:#FFF;background-color:#FFF;"/>
                                <div v-for="(acuerdo, index) in cedulaConResultado.Acuerdos" v-bind:key="acuerdo.AcuerdoId + index" class="row form-group">                                            
                                    <div class="col-4 form-group">
                                        <h6 for="cedula_urgente">Folio</h6>
                                        <input disabled="disabled" v-model="acuerdo.AcuerdoIdReferencia" type="text" class="form-control"/>
                                    </div>
                                    <div class="col-4 form-group">
                                        <h6 for="cedula_urgente">Fecha de publicación</h6>                                                
                                        <input disabled="disabled" :key="'FechaDePublicacionAMostrar'" v-model="acuerdo.FechaDePublicacionAMostrar" v-html="formatoFechaAcuerdo(acuerdo)" type="text" class="form-control"/>
                                    </div>                                            
                                    <div class="col-4 form-group">
                                        <h6 for="cedula_urgente">Es principal</h6>
                                        <input disabled="disabled" v-if="acuerdo.EsPrincipal" value="Si" type="text" class="form-control" />
                                        <input disabled="disabled" v-else value="No" type="text" class="form-control" />                                                
                                    </div>                                                                                    
                                </div>                                      
                            </div>
                            <div class="row col-12 form-group" style="padding-right: 0px;"> 
                                <div class="col-12">
                                    <h6 for="cedula_acuerdos">Resultado del área encargada</h6>  
                                    <hr style="height:1px;border:none;color:#FFF;background-color:#FFF;"/>
                                </div>
                                <div class="col-12 form-group">
                                    <h6>Estatus</h6>
                                    <input disabled="disabled" v-model="cedulaConResultado.Resultado.TipoResultado.Nombre" type="text" class="form-control" />
                                </div>
                                <div class="col-6 form-group" style="padding-right: 0px;">
                                    <h6>Observaciones</h6>
                                    <textarea disabled="disabled" :value="cedulaConResultado.Resultado.ObservacionesResultado" type="text" class="form-control" />
                                </div>   
                                <div class="col-6 form-group" v-if="cedulaConResultado.Resultado.TipoResultado.TipoResultadoId == 1" style="padding-right: 0px;">
                                    <h6>Razón</h6>
                                    <textarea disabled="disabled" :value="cedulaConResultado.Resultado.TipoRazon.Nombre" type="text" class="form-control" />
                                </div>                             
                            </div>                             
                        </div>                        
                    </div>
                    <div style="row col-10" class="text-right">
                        <button type="button" id="btn-datos-generales-cedula" class="btn btn-primary" @click="avanzarDePestana($event)">Siguiente&nbsp;&nbsp;<i class="fas fa-arrow-circle-right"></i></button>
                    </div>  
                </div>
                <div class="tab-pane fade" id="archivos-resultado-cedula" role="tabpanel" aria-labelledby="archivos-resultado-cedula-tab">
                    <div style="display: flex;">                        
                        <div class="row col-12">  
                            <div class="col-12 form-group">                            
                                <h6>Documentos del resultado</h6>
                                <hr style="height:2px;border:none;color:#FFF;background-color:#FFF;"/>
                            </div>                                                      
                            <div class="col-12 form-group" v-if="cedulaConResultado.Resultado.NombreArchivo != null && cedulaConResultado.Resultado.NombreArchivo != ''">
                                <h6>Archivo de resultado</h6>
                                <div class="input-group mb-1">
                                    <input disabled="disabled" v-model="cedulaConResultado.Resultado.NombreArchivo" type="text" class="form-control" />
                                    <div class="input-group-append" @click="verDocumento(cedulaConResultado.Resultado.ArchivoResultado_Ruta)">
                                        <span class="input-group-text"><span class="fas fa-file"></span></span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12" v-if="cedulaConResultado.Resultado.Anexos.length > 0">
                            <h6>Anexos</h6>
                            <div class="form-group mb-1" id="documentos_div" v-for="(documento, index) in cedulaConResultado.Resultado.Anexos" :key="index">
                                <div class="input-group mb-1">
                                    <input class="form-control" type="text" v-model="documento.Nombre" disabled />
                                    <div class="input-group-append" @click="verDocumento(documento.AnexoRuta)">
                                        <span :id="documento.referencia" class="input-group-text"><span :id="documento.referencia" class="fas fa-file"></span></span>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <h6>Archivo</h6>
                                <PDFDocument 
                                    :url="(this.esExtensionDeWord(parametrosDocumento.rutaArchivo) ? parametrosDocumento.rutaArchivo : '')" 
                                    :height="'600px'"
                                    
                                    :key="'ivoarch_resultado' + parametrosDocumento.key"
                                    :ArchivoAConvertir="(!this.esExtensionDeWord(parametrosDocumento.rutaArchivo) ? parametrosDocumento.archivo : null)"
                                    />
                            </div>
                            </div>
                        </div>
                    </div>
                    <br/>
                    <div style="row col-10" class="text-right">
                        <button type="button" id="btn-archivos-resultado-cedula" class="btn btn-primary" @click="avanzarDePestana($event)">Siguiente&nbsp;&nbsp;<i class="fas fa-arrow-circle-right"></i></button>
                    </div> 
                </div>
                <div class="tab-pane fade" id="resultado-cedula" role="tabpanel" aria-labelledby="resultado-cedula-tab">
                    <div style="display: flex;">
                        <div class="row col-12">
                            <div class="col-12 form-group">                            
                                <h6>Resultado</h6>
                                <hr style="height:2px;border:none;color:#FFF;background-color:#FFF;"/>
                            </div> 
                            <h5 class="col-12">Paso 1: Elige el tipo de resultado</h5>
                            <hr />                                                     
                            <div class="col-6 form-group">
                                <h6 for="indicar-como">Tipo de resultado:</h6>
                                    <i v-if="formularioResultado.mostrarMensajeError && this.campoRequeridoEsValido(parametros_TiposResultado.tipoResultadoId)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                    <i v-if="formularioResultado.mostrarMensajeError && !this.campoRequeridoEsValido(parametros_TiposResultado.tipoResultadoId)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                    <C015TiposDeResultado id="indicar-como" class="p-0 m-0" 
                                        v-on:valorParaElPadre="cambioTipoResultado($event)" 
                                        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                        :idDelInput="'resultadoCitatorio_TiposDeResultado'" 
                                        :valorDefinido="parametros_TiposResultado.tipoResultadoId"
                                        :parametros="parametros_TiposResultado.parametros"
                                        :key="parametros_TiposResultado.key"></C015TiposDeResultado>                                        
                            </div>                                
                            <div v-if="parametros_TiposResultado.esRazonada" class="col-6 form-group">
                                <h6>Tipo de razonamiento</h6>
                                    <i v-if="formularioResultado.mostrarMensajeError && this.campoRequeridoEsValido(parametros_TiposRazon.tipoRazonId)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                    <i v-if="formularioResultado.mostrarMensajeError && !this.campoRequeridoEsValido(parametros_TiposRazon.tipoRazonId)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                <C022TiposDeRazones class="p-0 m-0" v-on:valorParaElPadre="cambioTipoRazon" 
                                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                    :idDelInput="'resultadoCitatorio_TiposDeRazon'" 
                                    :parametros="parametros_TiposRazon.parametros"
                                    :valorDefinido="parametros_TiposRazon.tipoRazonId"
                                    :key="parametros_TiposRazon.key + parametros_TiposRazon.contRender"></C022TiposDeRazones>
                            </div>
                            <div class="col-6 form-group">
                                <h6>Observaciones</h6>
                                <textarea v-model="parametros_TiposResultado.observaciones" rows="3" type="text" class="form-control"/>
                            </div>  
                            <div v-if="parametros_TiposResultado.tipoResultadoId > 0" class="col-12">
                                <h5>Paso 2: Elige una plantilla para el resultado</h5>
                                <hr />
                                <i v-if="formularioResultado.mostrarMensajeError && this.campoRequeridoEsValido(parametros_Plantilla.plantillaId)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                    <i v-if="formularioResultado.mostrarMensajeError && !this.campoRequeridoEsValido(parametros_Plantilla.plantillaId)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                <C009TiposPlantilla class="p-0 m-0" 
                                    v-on:valorParaElPadre="cambioPlantilla" 
                                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                    :idDelInput="'resultadoCitatorio_Plantilla'" 
                                    :parametros="parametros_Plantilla.parametros"
                                    :valorDefinido="parametros_Plantilla.plantillaId"
                                    :key="parametros_Plantilla.key"></C009TiposPlantilla>                                    
                                <PDFDocument class="mt-2"
                                    :url="parametros_Plantilla.visorPdf.url" 
                                    :ArchivoAConvertir="parametros_Plantilla.visorPdf.archivo"
                                    :EsBase64="EsBase64"
                                    :EsBlob = "EsBlob" 
                                    :height="parametros_Plantilla.visorPdf.height"
                                    :key="'VDPRMULT' + parametros_Plantilla.visorPdf.contRender" />
                            </div>                          
                        </div>
                    </div>
                    <br />
                    <div v-if="parametros_Plantilla.visorPdf.url != null" style="row col-10" class="text-right">
                        <button type="button" id="btn-resultado-cedula" class="btn btn-primary" @click="avanzarDePestana($event)">Generar documento con datos&nbsp;&nbsp;<i class="fas fa-arrow-circle-right"></i></button>
                    </div>
                </div>
                <div class="tab-pane fade" id="generar-archivoresultado-cedula" role="tabpanel" aria-labelledby="generar-archivoresultado-cedula-tab">
                    <div style="display: flex;">
                        <div class="col-12 form-group">                            
                            <h6>Archivo de resultado con datos</h6>
                            <hr style="height:2px;border:none;color:#FFF;background-color:#FFF;"/>
                            <div class="row">
                                <div class="col-12 d-flex align-items-center">
                                <input type="file" id="archivoaSubir" 
                                    :class="(formularioResultado.mostrarError) ? 'border border-danger form-control mr-2' : 'form-control mr-2'" 
                                    v-on:change="actualizarDocumentoResultado($event)" accept=".DOC, .DOCX, .PDF" /> 
                                <div><button @click="evtDescargarDocumento" type="button" class="btn btn btn-success"><i class="fas fa-file-download"></i>&nbsp;Documento</button></div>
                                </div>
                                <div class="col-12">
                                    <PDFDocument class="mt-2"
                                    :url="parametros_ArchivoFinal.ruta" 
                                    :ArchivoAConvertir="parametros_ArchivoFinal.archivo"
                                    :EsBase64="EsBase64"
                                    :EsBlob = "EsBlob" 
                                    :height="'750px'"
                                    :key="parametros_ArchivoFinal.key + parametros_ArchivoFinal.contRender" />
                                </div>
                            </div>
                        </div> 
                    </div>
                    <div style="row col-10" class="text-right">
                        <button type="button" id="btn-guardar-cedula" class="btn btn-primary" @click="avanzarDePestana($event)"><i class="fas fa-save"></i>&nbsp;Guardar</button>
                    </div>
                </div>
            </div>
        </div>            
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import comun from '@/../static/js/comun'
import api from '@/../static/js/api'
import axios from 'axios'
import sistemas from '@/../static/js/sistemas'
import catalogos from '@/../static/js/catalogos'
import PDFDocument from '@/../src/components/Comunes/PDFDocument'
import Router from '@/router/index'

export default ({
    components: {
       comun,
       PDFDocument,  
       Router,     
       C015TiposDeResultado: catalogos.SINOJ.C015TiposDeResultado,
       C022TiposDeRazones: catalogos.SINOJ.C022TiposDeRazones,
       C009TiposPlantilla: catalogos.SINOJ.C009TiposPlantilla
    },
    data() {
        return { 
            EsBase64:{
                esBase64:false,
                archivoBase64:null
            },
            EsBlob:{
             esBlob:false,
             blob:null},
            enumeraciones,           
            folioCedula: null,
            cedulaConResultado: {
                Expediente: {
                    Juzgado: {
                        Nombre: null
                    },
                    TipoDocumento: {
                        Nombre: null
                    },
                    NumeroDeDocumento: null
                },
                TipoCedula: {
                    Nombre: null
                },
                Jurisdiccion: {
                    Area: { Nombre: null }
                },
                Resultado:{
                    TipoResultado: {
                        Nombre: null
                    },                    
                    NombreArchivo: null,
                    Anexos: []                 
                },                
            },
            parametrosDocumento:{
                key: "",
                rutaArchivo: null,
                archivo: null
            },
            formularioResultado: {                                
                mostrarMensajeError: false, 
                cedulaId: null,
                resultadoId: null                                                                           
            },
            parametros_TiposResultado: {
                key: "",
                esRazonada: false,
                tipoResultadoId: -1,
                observaciones:null,
                parametros: {}
            },
            parametros_TiposRazon: {
                key: "",                
                tipoRazonId: -1,                
                parametros: {}
            },
            parametros_Plantilla: {
                key: "",                
                plantillaId: -1,                            
                parametros: { 
                    TipoPlantillaId: null, 
                    Nombre: null, 
                    TipoCedulaId: null, 
                    TipoResultadoId: null, 
                    TipoRazonId: null, 
                    FechaInicial: null, 
                    FechaFinal: null, 
                    PlantillasDe: enumeraciones.sinoj.requierenPlantilla.razon.llave, 
                    ConInactivos: false, 
                    EsPrueba: false 
                },                                                                            
                plantilla: null,
                visorPdf: {
                    url: null,
                    height: '450px',
                    archivo: null,
                    contRender: 0
                }
            },
            parametros_ArchivoFinal: {
                ruta: null,
                archivo: null,
                contRender: 0,
                realizoCambios: true,
                key: "archivoFinal"
            }
        }
    },
    created(){
        this.folioCedula = Router.history.current.params.folio;
        
        if(this.folioCedula != undefined && this.folioCedula > 0)              
            this.cargarCedula();            
        else
            Router.push({ name: 'ConsultaJuzgado' });        
    },
    methods:{
        evtDescargarDocumento:function(){
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.href = `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${this.parametros_ArchivoFinal.ruta}`
            a.click();
        },
        actualizarDocumentoResultado: function (evento){
            try {
                if(this.verificaQueSeaElDocumentoCorrecto(evento)){
                if(evento.target.files.length > 0) {                    
                    this.parametros_ArchivoFinal.archivo = evento.target.files[0];
                    this.parametros_ArchivoFinal.ruta = '';                    
                    this.parametros_ArchivoFinal.contRender ++;
                    const nombreCortado = evento.target.files[0].name.split(".");   
                    this.parametros_ArchivoFinal.key = "visorDocumentoFinal" + nombreCortado;
                }
                else {
                    this.formularioResultado.mostrarMensajeError = true;
                    this.parametros_ArchivoFinal.archivo = null;
                }
                this.parametros_ArchivoFinal.realizoCambios = true;
                }
            }
            catch(error) {
                comun.mensajeDeAlerta(error);
            }
        },  
        verificaQueSeaElDocumentoCorrecto: function(evento) { debugger
            let siEsUnDocumentoValido = false;      
            //Se verifica que haya documento
            if(evento.target.files.length <= 0) {          
                $("#archivoaSubir").val('');
                this.parametros_ArchivoFinal.ruta = null;                     
                return siEsUnDocumentoValido;    
            }
            let extensionDocumento = ['doc', 'docx', 'pdf'];
            const nombreCortado = evento.target.files[0].name.split(".");        
            if (extensionDocumento.find(element => element.toLowerCase() == nombreCortado[nombreCortado.length - 1].toLowerCase()) != null)
                siEsUnDocumentoValido = true;
            else{
                let extensiones = "";
                extensionDocumento.forEach((element, index) => {
                extensiones += " ." + element;
                if(index < extensionDocumento.length - 1)
                    extensiones += ",";
                });
                comun.mensajeDeAlerta("El documento que esta subiendo no es un archivo permitido. El archivo debe ser " + extensiones + ".<br/><br/>Verifique el documento e inténtelo de nuevo.", null, null);
                $("#archivoaSubir").val('');
                this.archivo = null; 
          
              return siEsUnDocumentoValido;
            }
        
            return siEsUnDocumentoValido;
        },           
        crearCedulaNueva: function(){ 
            let cedula_core = {};
            cedula_core = this.cedulaConResultado;
            let resultadoObj = {};

            //Si ya se guardó la cédula la actualizamos
            if(this.formularioResultado.cedulaId != null){
                cedula_core.CedulaId = this.formularioResultado.cedulaId;
                resultadoObj.resultadoId = this.formularioResultado.cedulaId;
            }else{
                cedula_core.CedulaId = -1;
                resultadoObj.resultadoId = -1;
            }
            cedula_core.Estatus = {
                TipoEstatusId: enumeraciones.sinoj.tiposEstatus.finalizado
            };
            cedula_core.SeNotificaEnJuzgado = true;
            
            //Se establece cédula de referencia
            cedula_core.ReferenciaCedulaId = this.folioCedula;            

            //Defino nuevo resultado   
            if(this.parametros_TiposResultado.tipoResultadoId){                                
                resultadoObj.TipoResultado = {
                    TipoResultadoId: this.parametros_TiposResultado.tipoResultadoId
                };
            }
            
            if(this.parametros_TiposResultado.tipoResultadoId == enumeraciones.sinoj.tiposResultado.Razonada && !this.campoRequeridoEsValido(this.parametros_TiposRazon.tipoRazonId))  {      
                this.formularioResultado.mostrarMensajeError = true;
                comun.mensajeDeAlerta("Favor de indicar tipo de razonamiento", null, null);
            }else{
            resultadoObj.TipoRazon = {
                TipoRazonId: this.parametros_TiposRazon.tipoRazonId
            };
            }
            resultadoObj.ObservacionesResultado = this.parametros_TiposResultado.observaciones;
            resultadoObj.FechaResultado = moment();
            resultadoObj.ArchivoResultado_Ruta = this.parametros_Plantilla.visorPdf.url;   
            resultadoObj.Anexos = [];         
            cedula_core.Resultado = resultadoObj;
            return cedula_core;
        },   
        guardarResultado: async function() 
        {                  
            // this.formularioResultado.mostrarErroresPasoUno = false;
            //Declaro petición
            let peticion = new FormData();
            //Obtengo cédula nueva
            let cedulaNueva = await Promise.resolve(this.crearCedulaNueva());
            peticion.append('Cedula',JSON.stringify(cedulaNueva));            
            
            //Obtengo Plantilla    
            if(!this.campoRequeridoEsValido(this.parametros_Plantilla.plantillaId))  {      
                this.formularioResultado.mostrarMensajeError = true;
                comun.mensajeDeAlerta("Favor de indicar plantilla", null, null);
            }else{
                var plantilla = {
                    TipoPlantillaId: this.parametros_Plantilla.plantillaId
                }
                peticion.append('Plantilla', JSON.stringify(plantilla));
            }
            
            //Obtengo documento final
            
            if(this.parametros_ArchivoFinal.archivo != null){
                this.parametrosDocumento.archivo = this.parametros_ArchivoFinal.archivo;
            }
            peticion.append('DocumentoComplementado', this.parametrosDocumento.archivo);            
            peticion.append('EsPrueba',false);            
            
            if(!this.formularioResultado.mostrarMensajeError){
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + api.SINOJ.sistema.notificaciones.resultado.GuardarResultadoDeCitatorio,
                peticion,
                comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, true, false)
            ).then(respuesta => {
                if (respuesta.data.SiHayError) {                                    
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    console.log(respuesta);
                } else {                       
                    if(this.formularioResultado.cedulaId == null){          
                        this.formularioResultado.cedulaId = respuesta.data.CedulaId;        
                        this.parametros_ArchivoFinal.ruta = respuesta.data.RutaArchivo;
                        this.parametros_ArchivoFinal.key = "visorDocumentoFinal" + respuesta.data.RutaArchivo;
                                        
                        //Activo nueva ventana
                        $("#resultado-cedula-tab").removeClass('active');                    
                        $("#generar-archivoresultado-cedula-tab").removeClass('disabled');
                        $("#generar-archivoresultado-cedula-tab").trigger('click');
                    }else{
                        Router.push({ name: 'ConsultaJuzgado' });
                    }
                    comun.SeEstaCargandoInformacion(false);
                }
            })
            .then(response => {                  
            })
            .catch(e => {
                console.log("No Hay Respuesta del Servidor" + e);
                comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
            });
            }
        },
        campoRequeridoEsValido: function(campo) { 
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      },
        limpiarParametrosPlantillas: function(formulario) {
            this.parametros_Plantilla.parametros = { TipoPlantillaId: null, Nombre: null, TipoCedulaId: null, TipoResultadoId: null, TipoRazonId: null, FechaInicial: null, FechaFinal: null, PlantillasDe: enumeraciones.sinoj.requierenPlantilla.resultado.llave, ConInactivos: false, EsPrueba: false };
            this.parametros_Plantilla.plantilla = null;            
            this.parametros_Plantilla.visorPdf.url = null;
            this.parametros_Plantilla.archivo = null;            
        },
        cambioPlantilla: function(datos, tipoPlantillaObj){                     
            this.parametros_Plantilla.plantilla = tipoPlantillaObj;            
            this.parametros_Plantilla.plantillaId =  parseInt(datos.target.value);            
            
            if(tipoPlantillaObj != null)
                this.parametros_Plantilla.visorPdf.url = tipoPlantillaObj.Ruta;
            else
                this.parametros_Plantilla.visorPdf.url = '';

            this.parametros_Plantilla.visorPdf.contRender ++;
            this.formularioResultado.mostrarMensajeError = false;
            
        },
        cambioTipoRazon: function(datos){            
            this.parametros_TiposRazon.tipoRazonId = parseInt(datos.target.value);
            this.parametros_TiposRazon.key = "resultadoCitatorio_TiposDeRazon" + parseInt(datos.target.value);

            this.parametros_Plantilla.parametros.TipoRazonId =parseInt(datos.target.value);
            this.parametros_Plantilla.key = "resultadoCitatorio_TiposDeRazon" + parseInt(datos.target.value);
        },
        cambioTipoResultado: function(datos){            
            var resultadoId = parseInt(datos.target.value);
            this.parametros_TiposResultado.tipoResultadoId = resultadoId;
            this.limpiarParametrosPlantillas();
             
            if(resultadoId == enumeraciones.sinoj.tiposResultado.Razonada){
                this.parametros_TiposResultado.esRazonada = true;
            }else{
                this.parametros_TiposResultado.esRazonada = false;
            }                    

            this.parametros_Plantilla.parametros.TipoResultadoId = resultadoId;
            this.parametros_Plantilla.key = "resultadoCitatorio_TiposDeResultado" + resultadoId;
        },
        verDocumento: function(ruta){        debugger    
            this.parametrosDocumento.rutaArchivo = ruta;
            // this.parametrosDocumento.key = ruta
        },        
        esExtensionDeWord: function(rutaCompleta) { debugger
            if(rutaCompleta != null){
                let nombreArchivo = this.obtenerNombreArchivo(rutaCompleta);
                let esArchivoWord = false;            
                let nombreArray = nombreArchivo.split('.');
                const EXTENSION = nombreArray[nombreArray.length -1].toUpperCase();
                if(EXTENSION == 'DOC' || EXTENSION == 'DOCX') {
                    esArchivoWord = true;
                }else{
                    this.descargarArchivo(rutaCompleta);
                }                
                return esArchivoWord;
            }
        },
        descargarArchivo: async function(rutaArchivo) { debugger
            let archivo = null;
            const METODO_DESCARGA = `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${rutaArchivo}`;
            try {
                if(rutaArchivo != null) {
                    const PETICION_DESCARGA = await axios.get(METODO_DESCARGA, { responseType: 'blob' });
                    const ARCHIVO_DESCARGADO = await PETICION_DESCARGA.data;
                    let tipoArchivo = ARCHIVO_DESCARGADO.type;
                    // para pdf la API regresa un blob tipo application/octet-stream con arrayBuffer que no adminte el Object html del visos.
                    // solo hay que cambiar el tipo a uno que admita el cual es 'application/pdf'. 
                    if(tipoArchivo.startsWith('application/octet-stream')) {
                        tipoArchivo = 'application/pdf';
                    }
                    archivo = new File([ARCHIVO_DESCARGADO], 'archivoAnexo', { type: tipoArchivo });
                    
                    if(this.parametrosDocumento.archivo == null){
                        this.parametrosDocumento.archivo = archivo;
                        this.parametrosDocumento.key = "descargaArchivo_" + rutaArchivo;
                    }else{
                        if(archivo.name != this.parametrosDocumento.archivo.name){
                            this.parametrosDocumento.archivo = archivo;
                            this.parametrosDocumento.key = "descargaArchivo_" + rutaArchivo;
                        }
                    }
                }
            }
            catch(exeption) {
                console.log(exeption);
            }            
        },
        obtenerNombreArchivo: function(ruta){           
            if(ruta != null && ruta != "") {
                const ruta_archivo = ruta.split('\\');
                const nombre_archivo = ruta_archivo[ruta_archivo.length -1];
                return nombre_archivo;
            }
        },
        cargarCedula: function(){ 
            if(this.folioCedula != undefined && this.folioCedula > 0){                                      
                const peticion = { 
                    EsPrueba: this.enumeraciones.EsPrueba,
                    CedulaId : this.folioCedula
                }
                                
                comun.SeEstaCargandoInformacion(true);
                axios.post(api.conexion + api.SINOJ.sistema.cedulas.creacion.ObtenerCedula,
                    peticion,
                    comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
                ).then(respuesta => {
                    if (respuesta.data.SiHayError) {                                    
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                        console.log(respuesta);
                    } else {
                        if(respuesta.data.Cedula != null){    
                            if(respuesta.data.Cedula.Resultado != null){  
                            this.cedulaConResultado = respuesta.data.Cedula;  
                            this.cedulaConResultado.Resultado.NombreArchivo = this.obtenerNombreArchivo(this.cedulaConResultado.Resultado.ArchivoResultado_Ruta);
                            this.cedulaConResultado.Resultado.Anexos.forEach((anexo) => { 
                                anexo.Nombre = this.obtenerNombreArchivo(anexo.AnexoRuta);
                            });
                            
                            this.cedulaConResultado.Acuerdos.forEach((acuerdo) => {
                                acuerdo.FechaDePublicacionAMostrar = moment(acuerdo.FechaDePublicacion).format("DD-MM-YYYY");
                            });                            
                            }else{
                                comun.mensajeDeAlerta("La cédula no tiene resultado.", null, null);
                                comun.mensajeDeAlerta("No se pudo obtener la cédula.", null, null);
                                Router.push({ name: 'ConsultaJuzgado' });
                            }
                        }else
                            comun.mensajeDeAlerta("No se pudo obtener la cédula.", null, null);
                    }
                    comun.SeEstaCargandoInformacion(false);
                })
                .then(response => {
                    
                })
                .catch(e => {
                console.log("No Hay Respuesta del Servidor" + e);
                comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
                });
            }else{
                this.mostrarErroresEnDatosGenerales = true;
                comun.mensajeDeAlerta('Se detectaron campos incorrectos. Favor de verificarlos.', null, null);
            }
        },
        formatoFechaAcuerdo: function(acuerdo){
            let formatoFecha = acuerdo.FechaDePublicacion.split('T');
            if(acuerdo.FechaDePublicacion && formatoFecha.length > 1){                             
                acuerdo.FechaDePublicacionAMostrar = moment(acuerdo.FechaDePublicacion).format("DD-MM-YYYY");                
            }            
        },
        avanzarDePestana: function(evento) { 
            const pestañaId = evento.target.getAttribute('id');
            switch(pestañaId) { 
                case 'btn-datos-generales-cedula':
                    $("#datos-generales-cedula-tab").removeClass('active');
                    $("#archivos-resultado-cedula-tab").removeClass('disabled');
                    $("#archivos-resultado-cedula-tab").trigger('click');
                    break;
                case 'btn-archivos-resultado-cedula':                    
                    $("#archivos-resultado-cedula-tab").removeClass('active');
                    $("#resultado-cedula-tab").removeClass('disabled');
                    $("#resultado-cedula-tab").trigger('click');                 
                    break;                
                case 'btn-resultado-cedula':
                case 'btn-guardar-cedula':   
                    this.guardarResultado();                                                        
                    break;
                default:
                    break;
            } 
        },
    }
})
</script>
<style scoped>
    .nav_tab_formularios {
        padding: 25px;
        background-color: #323335;
        box-shadow: 0px 6px 20px 4px #161616;
    }
    .nav-tabs
    {
        border-bottom: 1px solid white;
    }

    .nav-item>a.active, 
    .nav-item>a.active:focus, 
    .nav-item>a.active:hover {
        background-color: #323335;
        color: white;
        border-bottom: 1px solid #323335;
    }
    .nav-item>a{
        border-bottom: 1px solid white;
    }
</style>


// WEBPACK FOOTER //
// src/components/SINOJ/Notificaciones/Resultados/ResultadoCitatorio.vue